import { render, staticRenderFns } from "./CatGastos.vue?vue&type=template&id=0890adf2"
import script from "./CatGastos.vue?vue&type=script&lang=js"
export * from "./CatGastos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0890adf2')) {
      api.createRecord('0890adf2', component.options)
    } else {
      api.reload('0890adf2', component.options)
    }
    module.hot.accept("./CatGastos.vue?vue&type=template&id=0890adf2", function () {
      api.rerender('0890adf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/settings/CatGastos.vue"
export default component.exports